import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
	{ field: 'id', headerName: 'CART ID', width: 150 },
	{
		field: 'depart',
		headerName: 'TYPE',
		width: 150,
		editable: true,
	},
	{
		field: 'journey',
		headerName: 'DOJ',
		width: 150,
		editable: true,
	},
	{
		field: 'dob',
		headerName: 'AMOUNT',
		type: 'number',
		width: 150,
		editable: true,
	},
	{
		field: 'journeydate',
		headerName: 'AVIALABLE BALANCE',
		width: 160,
		type: 'number',
		editable: true,
	},
	{
		field: 'cost',
		headerName: 'TICKET COST',
		type: 'number',
		width: 150,
		editable: true,
	},
	{
		field: 'PTYPE',
		headerName: 'PAYMENT TYPE',
		type: 'number',
		width: 150,
		editable: true,
	},
	{
		field: 'DATE',
		headerName: 'DATE',
		type: 'number',
		width: 150,
		editable: true,
	},
	{
		field: 'DESC',
		headerName: 'DESCRIPTION',
		type: 'number',
		width: 150,
		editable: true,
	},
];

const rows = [
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
];

export default function TransactionHistory() {
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			<DataGrid
				rows={rows}
				columns={columns}
				initialState={{
					pagination: {
						paginationModel: {
							pageSize: 5,
						},
					},
				}}
				pageSizeOptions={[5]}
				checkboxSelection
				disableRowSelectionOnClick
			/>
		</Box>
	);
}
